import React from "react";
import ApplePay from "components/PaymentMethodIcons/ApplePay";
import GooglePay from "components/PaymentMethodIcons/GooglePay";
import { COLORS } from "utils/styles";
import { getIconForUID } from "components/FormerEditor/utils";

const Icon = getIconForUID("checkmark");

const DEFAULT_CLASSES = {
  container: "flex flex-column w-100 pt3",
  header: "flex flex-row justify-between items-center"
};

const MESSAGE = {
  ENABLED:
    "Apple Pay and Google Pay methods are automatically shown to customers at checkout where they are relevant and supported by device.",
  // https://stripe.com/docs/tax/checkout#create-session
  DISABLED:
    "Apple Pay and Google Pay methods are not available when automatic tax collection is enabled."
};

const DigitalWalletPrompt = ({ customClasses, enabled }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className="f6 fw5 db">Digital wallets</div>
        <Icon size={20} color={enabled ? COLORS.blue : COLORS.secondary} />
      </div>
      <div className="f6 pt2 lh-copy">
        {enabled ? MESSAGE.ENABLED : MESSAGE.DISABLED}
      </div>
      <div className="flex flex-row pt2 mt1">
        <div className="pv1 pr1">
          <ApplePay />
        </div>
        <div className="pa1">
          <GooglePay />
        </div>
      </div>
    </div>
  );
};
export default DigitalWalletPrompt;
